export default ({ request }) => ({
  projectInfoListApi(data = {}) {
    return request({
      url: '/digitalCenter/project/info/list',
      method: 'post',
      data,
    })
  },
  cartProjectListInfoApi(data = {}) {
    return request({
      url: '/digitalCenter/project/info/cartProjectList',
      method: 'post',
      data,
    })
  },
  projectInfoDetailApi(data = {}) {
    return request({
      url: '/digitalCenter/project/info/detail',
      method: 'post',
      data,
    })
  },
  projectInfoSaveApi(data = {}) {
    return request({
      url: '/digitalCenter/project/info/save',
      method: 'post',
      data,
    })
  },
  projectInfoAddApi(data) {
    return request({
      url: '/digitalCenter/project/info/add',
      method: 'post',
      data,
    })
  },
  projectInfoDelApi(data) {
    return request({
      url: '/digitalCenter/project/info/del',
      method: 'post',
      data,
    })
  },
  projectInfoViewDetailApi(data = {}) {
    return request({
      url: '/digitalCenter/project/info/viewDetail',
      method: 'post',
      data,
    })
  },
  projectInfoCompleteApi(data = {}) {
    return request({
      url: '/digitalCenter/project/info/complete',
      method: 'post',
      data,
    })
  },
  projectInfoUpdateStatusApi(data = {}) {
    return request({
      url: '/digitalCenter/project/info/updateStatus',
      method: 'post',
      data,
    })
  },
  projectInfoSubPrjectListApi(data = {}) {
    return request({
      url: '/digitalCenter/project/info/subPrjectList',
      method: 'post',
      data,
    })
  },
  projectInfoCopyApi(data) {
    return request({
      url: '/digitalCenter/project/info/copy',
      method: 'post',
      data,
    })
  },
})
